import { Grid, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  deleteCandidateCertification,
  deleteCandidateDegree,
  fetchCandidateCertifications,
  fetchCandidateDegrees,
  postCandidateCertification,
  postCandidateDegree
} from '../../api/candidate';
import useFetch from '../../hooks/useFetch';
import useNotification from '../../hooks/useNotification';
import useDebounce from '../../hooks/useDebounce';
import Certifications from '../certifications';
import Section from '../common/section';
import Degrees from '../degrees';
import DegreeForm from '../forms/degree';
import CertificationForm from '../forms/certification';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '1.5625rem 1.25rem',
  }
});

const Education = ({ edit, reloadCandidateUpdatedAtData }) => {
  const { hash } = useParams();
  const classes = useStyles();
  const [degreeChanges, setDegreeChanges] = useState(0);
  const [certificationChanges, setCertificationChanges] = useState(0);
  /*
  const isEnabled = useRouteMatch({
    path: '/candidates/:hash/edit',
    exact: true,
  });
  */
  const { result: degrees } = useFetch(fetchCandidateDegrees, hash, [hash, degreeChanges]);
  const { result: certifications } = useFetch(
    fetchCandidateCertifications,
    hash,
    [hash, certificationChanges]
  );
  const notifications = useNotification();
  const [degreeDisabled, setDegreeDisabled] = useState(false);
  const [certificationDisabled, setCertificationDisabled] = useState(false);

  const handleAddDegree = useDebounce(( { title, year, university }) => {
    setDegreeDisabled(true);
    postCandidateDegree(hash, { immediately: true, title, year, university })
    .then((res) => {
      if(res.success) {
        setDegreeChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData();
        notifications.success({ message: 'Degree was successfully added', });
      } else {
        notifications.error(res.error);
      }
    })
    .finally(() => {
      setDegreeDisabled(false);
    })
  }, 1000);

  const handleAddCertification = useDebounce(( { title, year, institution }) => {
    setCertificationDisabled(true);
    postCandidateCertification(hash, { immediately: true, title, year, institution })
    .then((res) => {
      if(res.success) {
        setCertificationChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData();
        notifications.success({ message: 'Certification was successfully added', });
      } else {
        notifications.error(res.error);
      }
    })
    .finally(() => {
      setCertificationDisabled(false);
    })
  }, 1000);

  const handleDeleteDegree = useDebounce((degree) => {
    deleteCandidateDegree(hash, { immediately: true, degree })
    .then((res) => {
      if(res.success) {
        setDegreeChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData();
        notifications.success({ message: 'Degree was successfully deleted', });
      } else {
        notifications.error(res.error);
      }
    })
  }, 1000);

  const handleDeleteCertification = useDebounce((certification) => {
    deleteCandidateCertification(hash, { immediately: true, certification })
    .then((res) => {
      if(res.success) {
        setCertificationChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData();
        notifications.success({ message: 'Certification was successfully deleted', });
      } else {
        notifications.error(res.error);
      }
    })
  }, 1000);

  if (!edit && !degrees && !certifications) return null;

  if (
    !edit &&
    Array.isArray(degrees) &&
    !degrees.length &&
    Array.isArray(certifications) &&
    !certifications.length
  )
    return null;

  if (certifications?.length > 1) {
    certifications.sort(function (a, b) {
      return ((a['year'] > b['year']) ? -1 : ((a['year'] < b['year']) ? 1 : 0));
    });
  }

  if (degrees?.length > 1) {
    degrees.sort(function (a, b) {
      return ((a['year'] > b['year']) ? -1 : ((a['year'] < b['year']) ? 1 : 0));
    });
  }

  return (
    <Section title="Education" /*disabled={!isEnabled}*/>
      <Grid container spacing={2}>
        {Array.isArray(degrees) && degrees.length > 0 && (
          <Grid item xs={12} md={6}>
            <Degrees edit={edit} degrees={degrees} onDelete={handleDeleteDegree} />
          </Grid>
        )}
        {edit &&
          <Grid item className={classes.root} xs={12} md={12}>
            <DegreeForm disabled={degreeDisabled} onSubmit={handleAddDegree} />
          </Grid>
        }
        {Array.isArray(certifications) && certifications.length > 0 && (
          <Grid item xs={12} md={12}>
            <Certifications 
              edit={edit} 
              certifications={certifications} 
              onDelete={handleDeleteCertification}
              reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData}
            />
          </Grid>
        )}
        {edit &&
          <Grid item className={classes.root} xs={12} md={12}>
            <CertificationForm disabled={certificationDisabled} onSubmit={handleAddCertification} />
          </Grid>
        }
      </Grid>
    </Section>
  );
};

export default Education;
